module.exports = __webpack_public_path__ + "static/img/user4.b1d9b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user4.png
// module id = D7bA
// module chunks = 1